<template>
  <layout :title="$route.name" :toolbar_off="true">
    <v-flex xs12 class="pa-3 pb-0">
      <div class="expande-horizontal centraliza">
        <div class="expande-horizontal column title-item">
          <v-avatar
            @click="$router.go(-1)"
            size="36"
            style="cursor: pointer;"
            color="#e5e5e5"
          >
            <v-icon color="#000" size="26">mdi-arrow-left</v-icon>
          </v-avatar>
        </div>
        <div class="deposit-title">
          <v-icon color="#666" size="38" class="deposit-title__icon">
            mdi-qrcode-pius
          </v-icon>
          <span class="fonte-bold deposit-title__text">Adicionar via Pix</span>
        </div>
      </div>
    </v-flex>

    <v-window touchless v-model="step">
      <v-window-item value="form">
        <v-flex xs12 class="px-3" md6>
          <div class="pt-6 mb-6 centraliza expande-horizontal wrap">
            <v-flex xs12>
              <v-alert v-if="error" type="error" outlined>{{ error }}</v-alert>
            </v-flex>

            <v-flex xs12>
              <v-list class="fonte pa-0" color="transparent">
                <v-list-item class="px-0">
                  <v-avatar color="#333" rounded class="mr-2">
                    <v-icon color="#f2f2f2">mdi-qrcode</v-icon>
                  </v-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="fonte-bold">Pix</v-list-item-title>
                    <v-list-item-subtitle>
                      Único método disponível para adicionar saldo
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-flex>

            <v-flex class="px-1" xs12>
              <span class="fonte-bold deposit-heading">Valor do depósito</span>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                filled
                color="black"
                rounded
                prefix="R$"
                inputmode="decimal"
                v-mask="[
                  '#,##',
                  '##,##',
                  '###,##',
                  '####,##',
                  '##.###,##',
                  '###.###,##'
                ]"
                :rules="[value => amountInCents(value) >= 500 || 'O valor mínimo é R$ 5,00']"
                v-model="value"
                autofocus
              />
            </v-flex>
            <v-flex xs12>
              <v-alert type="info" text dense>
                O saldo será liberado na Conta SCN após a confirmação do pagamento Pix.
              </v-alert>
            </v-flex>
            <v-flex xs12>
              <v-btn
                @click="request"
                :loading="loading"
                x-large
                color="#333"
                dark
                rounded
              >
                Gerar Pix
              </v-btn>
            </v-flex>
          </div>
        </v-flex>
      </v-window-item>

      <v-window-item value="pix">
        <v-flex xs12 class="px-3" md6>
          <div class="pt-6 mb-6 centraliza expande-horizontal wrap">
            <v-flex xs12>
              <v-alert v-if="error" type="error" outlined>{{ error }}</v-alert>
            </v-flex>

            <v-flex xs12 class="text-center">
              <span class="fonte-bold deposit-heading">Pix gerado com sucesso</span>
              <p class="fonte grey--text mt-2">
                Escaneie o QR Code ou copie o código Pix abaixo.
              </p>
              <p v-if="operation" class="fonte-bold mb-2">
                Valor: {{ formatAmount(operation.amount) }}
              </p>
              <div v-if="pixCode" class="deposit-qr my-5">
                <qrcode-vue
                  :value="pixCode"
                  :size="220"
                  class="deposit-qr__canvas"
                />
              </div>
            </v-flex>

            <v-flex xs12 v-if="pixCode">
              <v-textarea
                :value="pixCode"
                label="Pix copia e cola"
                readonly
                outlined
                rows="4"
              />
              <v-btn block outlined color="#333" @click="copyPix">
                <v-icon left>mdi-content-copy</v-icon>
                Copiar código Pix
              </v-btn>
            </v-flex>

            <v-flex xs12 class="mt-4">
              <v-alert :type="statusType" text>{{ statusText }}</v-alert>
            </v-flex>

            <v-flex xs12 class="centraliza">
              <v-btn v-if="isFinished" text color="#333" @click="newDeposit">
                Fazer novo depósito
              </v-btn>
            </v-flex>
          </div>
        </v-flex>
      </v-window-item>
    </v-window>

    <v-dialog :value="showSuccess" fullscreen persistent transition="dialog-bottom-transition">
      <v-card class="deposit-success-screen">
        <div class="deposit-success-screen__content text-center px-6">
          <v-icon color="success" size="112">mdi-check-circle</v-icon>
          <h1 class="fonte-bold mt-5">Pix confirmado!</h1>
          <p class="deposit-success-screen__amount mt-4 mb-2">
            {{ operation ? formatAmount(operation.amount) : "" }}
          </p>
          <p class="fonte mb-8">
            O pagamento foi recebido e o saldo já está disponível na sua conta unilevel.
          </p>
          <v-btn x-large rounded color="success" dark block @click="finishSuccess">
            Ver meu saldo
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </layout>
</template>

<script>
import { mapActions } from "vuex";
import QrcodeVue from "qrcode.vue";

const FINISHED_STATUSES = [
  "COMPLETED",
  "FAILED",
  "REFUNDED",
  "CHARGEBACK",
  "CHARGEDBACK",
  "CANCELED",
  "REJECTED"
];

export default {
  components: { QrcodeVue },
  data() {
    return {
      value: "",
      step: "form",
      loading: false,
      error: "",
      operation: null,
      idempotencyKey: null,
      pollTimer: null
    };
  },
  computed: {
    pixCode() {
      const pix = this.operation && this.operation.pix;
      return pix && (pix.copyPaste || pix.qrcode || pix.qrcodeUrl);
    },
    isFinished() {
      return this.operation && FINISHED_STATUSES.includes(this.operation.status);
    },
    showSuccess() {
      return Boolean(this.operation && this.operation.status === "COMPLETED");
    },
    statusType() {
      if (!this.operation) return "info";
      if (this.operation.status === "COMPLETED") return "success";
      if (["FAILED", "REFUNDED", "CHARGEBACK", "CHARGEDBACK", "CANCELED", "REJECTED"].includes(this.operation.status)) {
        return "error";
      }
      return "info";
    },
    statusText() {
      if (!this.operation) return "";
      if (this.operation.status === "COMPLETED") {
        return "Pagamento confirmado. O saldo já está disponível na Conta SCN.";
      }
      if (this.operation.status === "FAILED") {
        return this.isExpired
          ? "Este Pix expirou. Gere uma nova cobrança para continuar."
          : "Não foi possível concluir este Pix. Ele pode ter expirado ou sido recusado; gere uma nova cobrança.";
      }
      if (["CANCELED", "REJECTED"].includes(this.operation.status)) {
        return "Este Pix foi cancelado ou expirou. Gere uma nova cobrança.";
      }
      if (["REFUNDED", "CHARGEBACK", "CHARGEDBACK"].includes(this.operation.status)) {
        return "O pagamento foi estornado.";
      }
      if (this.operation.status === "PROCESSING") {
        return "Pagamento identificado e em processamento pela Petta.";
      }
      if (this.operation.status === "BLOCKED_REVIEW") {
        return "Pagamento em análise pela Petta.";
      }
      return "Aguardando pagamento. O status é conferido automaticamente com a Petta.";
    },
    isExpired() {
      const reason = `${(this.operation && this.operation.failureReason) || ""}`;
      return /expir|vencid|timeout/i.test(reason);
    }
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    ...mapActions(["requestDeposit", "getDeposit", "listBalanceUnilevel", "createGlobalMessage"]),
    amountInCents(value = this.value) {
      const normalized = `${value || ""}`.replace(/\./g, "").replace(",", ".");
      const amount = Number(normalized);
      return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
    },
    formatAmount(cents) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(Number(cents || 0) / 100);
    },
    newIdempotencyKey() {
      return `deposit_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    },
    async request() {
      if (this.amountInCents() < 500) {
        this.error = "O valor mínimo para depósito é R$ 5,00.";
        return;
      }

      this.loading = true;
      this.error = "";
      this.idempotencyKey = this.idempotencyKey || this.newIdempotencyKey();

      try {
        const response = await this.requestDeposit({
          value: this.value,
          type: "pix",
          idempotencyKey: this.idempotencyKey
        });
        this.operation = response.data;
        this.step = "pix";
        this.startPolling();
      } catch (error) {
        this.error =
          (error.response && error.response.data && error.response.data.message) ||
          "Não foi possível gerar o Pix.";
        this.idempotencyKey = null;
      } finally {
        this.loading = false;
      }
    },
    startPolling() {
      this.stopPolling();
      if (!this.operation || this.isFinished) return;

      this.pollTimer = setTimeout(async () => {
        try {
          const response = await this.getDeposit(this.operation.id);
          this.operation = response.data;
          this.error = "";
        } catch (error) {
          this.error = "Não foi possível atualizar o status do Pix.";
        } finally {
          this.startPolling();
        }
      }, 4000);
    },
    stopPolling() {
      if (this.pollTimer) clearTimeout(this.pollTimer);
      this.pollTimer = null;
    },
    async copyPix() {
      if (!this.pixCode) return;

      try {
        await navigator.clipboard.writeText(this.pixCode);
        this.createGlobalMessage({
          type: "success",
          message: "Código Pix copiado com sucesso!",
          timeout: 3000
        });
      } catch (error) {
        this.error = "Não foi possível copiar automaticamente. Selecione o código acima.";
      }
    },
    async finishSuccess() {
      this.stopPolling();
      try {
        await this.listBalanceUnilevel();
      } catch (error) {
        // O dashboard tenta carregar novamente; a confirmação não deve ficar presa por isso.
      }
      this.$router.push("/dashboard");
    },
    newDeposit() {
      this.stopPolling();
      this.value = "";
      this.operation = null;
      this.idempotencyKey = null;
      this.error = "";
      this.step = "form";
    }
  }
};
</script>

<style scoped>
.deposit-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
}

.deposit-title__icon {
  padding-bottom: 3px;
}

.deposit-title__text {
  font-size: 19pt;
  white-space: nowrap;
}

.deposit-heading {
  font-size: 24pt;
}

.deposit-qr {
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.deposit-qr__canvas {
  display: block;
  max-width: 100% !important;
  height: auto !important;
}

.deposit-success-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #fff;
}

.deposit-success-screen__content {
  width: 100%;
  max-width: 440px;
}

.deposit-success-screen__amount {
  color: #2e7d32;
  font-size: 34px;
  font-weight: 800;
}

@media (max-width: 320px) {
  .deposit-qr__canvas {
    width: calc(100vw - 48px) !important;
  }
}
</style>
